module.exports = __webpack_public_path__ + "static/media/zoomout.ed00a6e5.svg";